/**
 * Firebase / callable auth outcomes that are expected when the UI and backend
 * disagree on access, or when tokens lack entity access (report-reader, etc.).
 */
const AUTH_CODES = [
  'permission-denied',
  'unauthenticated',
  'functions/permission-denied',
  'functions/unauthenticated',
] as const;

const AUTH_MESSAGES = ['User not authorized', 'Operation not allowed'] as const;

const codeEndsWith = (code: string, suffix: string): boolean =>
  code === suffix || code.endsWith(`/${suffix}`);

const isExpectedAuthError = (error: unknown): boolean => {
  if (!error || typeof error !== 'object') {
    return false;
  }

  const maybeError = error as { code?: unknown; message?: unknown };
  const code = typeof maybeError.code === 'string' ? maybeError.code : '';
  const message = typeof maybeError.message === 'string' ? maybeError.message : '';

  if (AUTH_CODES.some(c => code === c || codeEndsWith(code, c.replace(/^functions\//, '')))) {
    if (!message || AUTH_MESSAGES.some(m => message === m || message.includes(m))) {
      return true;
    }
    if (
      codeEndsWith(code, 'permission-denied') ||
      codeEndsWith(code, 'unauthenticated') ||
      code === 'functions/permission-denied' ||
      code === 'functions/unauthenticated'
    ) {
      return true;
    }
  }

  if (AUTH_MESSAGES.some(m => message === m)) {
    return true;
  }

  return false;
};

export { isExpectedAuthError };
